import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum CounterNames {
  Visits = 'newVisits',
  Likes = 'newLikes',
  Matches = 'newMatches',
}

interface CounterPayload {
  [CounterNames.Visits]: number;
  [CounterNames.Likes]: number;
  [CounterNames.Matches]: number;
}

interface NotificationState {
  counters: CounterPayload;
  isFirstLoading: boolean;
}

const notificationsInitialState: NotificationState = {
  counters: {
    newVisits: 0,
    newLikes: 0,
    newMatches: 0,
  },
  isFirstLoading: true,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: notificationsInitialState,
  reducers: {
    setNewNotifications: (state, action: PayloadAction<CounterPayload>) => {
      state.counters = { ...action.payload };
    },
    clearCounterNotification: (state, action: PayloadAction<CounterNames>) => {
      state.counters = {
        ...state.counters,
        [action.payload]: 0,
      };
    },
    setIsFirstLoading: (state) => {
      state.isFirstLoading = false;
    },
  },
});

export const {
  setNewNotifications,
  clearCounterNotification,
  setIsFirstLoading,
} = notificationsSlice.actions;

export const notifications = notificationsSlice.reducer;
